<template>
    <button type="button"
            class="btn btn-primary"
            v-on:click="submit()">
        <slot></slot>
    </button>
</template>

<script>

import axios from 'axios';

export default {
    props: {
        url: {
            required: true,
            type: String,
        },
    },
    methods: {
        submit() {
            axios.get(this.url)
                .then(({data}) => {
                    this.fillForm(data);
                })
                .catch(error => {
                    alert(this.$getAjaxErrorString(error));
                });
        },

        fillForm(data) {
            this.$parent.$el.querySelectorAll('input, select')
                .forEach((element) => {

                    let dataIndex = element.attributes.name.value;

                    if (typeof data[dataIndex] === 'undefined') {
                        return;
                    }

                    let value = data[dataIndex];
                    element.value = '';

                    switch (element.nodeName) {
                        case 'SELECT':
                            element.querySelectorAll('option')
                                .forEach((optionElement) => {
                                    if (optionElement.value === value) {
                                        element.value = value;
                                    }
                                });
                            break;
                        default:
                            element.value = value;
                            break;
                    }
                });
        }
    }
}
</script>

<style scoped>

</style>
